<template>
  <div class="basket-mobile-layout">
    <div class="basket-mobile-layout__body">
      <tabs-page
        class="basket-mobile-layout__tabs-holder"
        :current-tab="currentTab"
        @changeTab="handleChange"
      />
      <div class="basket-mobile-layout__content">
        <div class="basket-mobile-layout__count-item"></div>
        <slot></slot>
      </div>
    </div>
    <lazy-hydrate v-if="showSidebar">
      <div class="basket-mobile-layout__summary">
        <slot name="sidebar"></slot>
      </div>
    </lazy-hydrate>
    <transition name="component-fade" mode="out-in">
      <div v-if="showTotalButton" ref="buttonHolder" class="basket-mobile-layout__total-button">
        <button-control
          is-block
          size="large"
          :disabled="isDisabledOrderButton"
          :is-added-disabled-class-name="isDisabledOrderButton"
          :loading="isLoading"
          :class="{ '_two-lines': !isDeletedAll, _scroll: isScroll }"
          @click="handlerClickButtonGoCheckout"
        >
          Перейти к оформлению
          <span v-if="!isDeletedAll" class="b24-btn__second-line">
            {{ amountDiscounted }} без доставки
          </span>
        </button-control>
      </div>
    </transition>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from '@vue/composition-api';
import { ButtonControl } from '@book24/ui-components';
import LazyHydrate from 'vue-lazy-hydration';

import { BASKET_TAB_VALUE } from '@/enums';
import { AMOUNT_DEFAULT_VALUE } from '@/compositions/basket/basketStorage';

import { useLocationContext } from '@/compositions/location/locationStorage';

import TabsPage from '@/components/TabsPage/index.vue';
import { priceFormatted } from '@/utils/formatters/formattedPrice';

export default defineComponent({
  name: 'LayoutPage',
  components: {
    ButtonControl,
    TabsPage,
    LazyHydrate,
  },
  props: {
    showSidebar: { type: Boolean, default: true },
    currentTab: { type: String, default: BASKET_TAB_VALUE },
    isDeletedAll: { type: Boolean, default: false },
    showTotalButton: { type: Boolean, default: true },
    amount: { type: Object, default: () => ({ ...AMOUNT_DEFAULT_VALUE }) },
    isLoading: { type: Boolean, default: false },
    unavailableItemsLength: { type: Number, default: 0 },
  },
  setup(props, { emit }) {
    const { isUaOrGb } = useLocationContext();

    const buttonHolder = ref(null);

    const isScroll = ref(true);

    const amountDiscounted = computed(() => priceFormatted(props.amount.discounted, { setFreeText: false }));

    const isDisabledOrderButton = computed(() => !!(props.isDeletedAll
        || isUaOrGb.value || props.unavailableItemsLength || props.isLoading));

    const handleChange = type => emit('changeTab', type);

    const handlerClickButtonGoCheckout = () => emit('clickButtonGoCheckout');

    const checkSticky = () => {
      if (buttonHolder.value) {
        const observer = new IntersectionObserver(
          ([e]) => {
            isScroll.value = e.intersectionRatio < 1;
          },
          { rootMargin: '0px 0px -1px 0px', threshold: [1] },
        );

        observer.observe(buttonHolder.value);
      }
    };

    onMounted(() => checkSticky());

    return {
      isUaOrGb,
      amountDiscounted,
      buttonHolder,
      isScroll,
      isDisabledOrderButton,
      handleChange,
      handlerClickButtonGoCheckout,
    };
  },
});
</script>

<style lang="less">
.basket-mobile-layout {

  background: @white;

  &__tabs-holder {
    border-bottom: 1px solid @gray-super-light;
    display: flex;
    justify-content: space-between;
  }

  &__content {
    padding-top: @size-x4;
  }

  &__total-button {
    position: sticky;
    padding: @size-x4;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 2;
    bottom: 0;
    transition: @A background-color;
  }
}
</style>
